import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getPatientAging } from 'api/Billing';

import { DEFAULT_QUERY_OPTIONS } from 'lib/constants/queries/defaultQueryOptions';

export const usePatientAging = ({ params = {}, options = {}, dependencies = [] } = {}) => {
  const navigate = useNavigate();
  return useQuery(['patient_aging', ...dependencies], () => getPatientAging(navigate, params), {
    ...DEFAULT_QUERY_OPTIONS,
    ...options
  });
};
